/*
 * This is a modified file based on the chartist-plugin-tooltip
 * package. Unfortunately, we can't say exactly what version this
 * is based off of, since we originally vendored the file, and it
 * lacked any version information. This is modified to export a
 * function that can be used to mutate the Chartist object, instead of
 * self-calling itself to do just that. This way it's more explicit
 * how those side-effects are applied to Chartist.
 */
const Chartist = require('chartist');

/**
 * Chartist.js plugin to display a data label on top of the points in a line chart.
 *
 */
function register(Chartist) {
  'use strict';

  var defaultOptions = {
    currency: '$',
    labelOffset: {
      x: 0,
      y: -5,
    },
    // showTooltips: true,
    // tooltipEvents: ['mousemove', 'touchstart', 'touchmove'],
    // labelClass: 'ct-label',
    // labelOffset: {
    //   x: 0,
    //   y: -10
    // },
    // textAnchor: 'middle'
  };

  Chartist.plugins = Chartist.plugins || {};
  Chartist.plugins.tooltip = function (options) {

    options = Chartist.extend({}, defaultOptions, options);

    return function tooltip(chart) {
      var tooltipSelector = '.ct-point';
      if (chart instanceof Chartist.Bar) {
        tooltipSelector = '.ct-bar';
      } else if (chart instanceof Chartist.Pie) {
        // Added support for donut graph
        if (chart.options.donut) {
          tooltipSelector = '.ct-slice-donut';
        } else {
          tooltipSelector = '.ct-slice-pie';
        }
      }

      var $chart = $(chart.container);
      var $toolTip = $chart
      .append('<div class="chartist-tooltip"></div>')
      .find('.chartist-tooltip')
      .hide();

      function _tooltipMouseenter(point) {
        var $point = $(point);
        var tooltipText = '';

        if (options.tooltipFnc) {
          tooltipText = options.tooltipFnc($point.attr('ct:meta') || '', $point.attr('ct:value'));
        } else {
          if ($point.attr('ct:meta')) {
            tooltipText += $point.attr('ct:meta') + '<br>';
          } else {
            // For Pie Charts also take the labels into account
            // Could add support for more charts here as well!
            if (chart instanceof Chartist.Pie) {
              var label = $point.next('.ct-label');
              if (label.length > 0) {
                tooltipText += label.text() + '<br>';
              }
            }
          }

          var value = $point.attr('ct:value');
          if (!$.isEmptyObject(options.currency)) {
            value = options.currency + value.replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,');
          }
          tooltipText += value;
        }

        $toolTip.html(tooltipText).show();
      }

      function _tooltipMouseleave() {
        $toolTip.hide();
      }

      chart.on('draw', function () {
        $(tooltipSelector).on('mouseenter', function () {
          _tooltipMouseenter(this);
        }).on('mouseleave', function () {
          _tooltipMouseleave();
        });
      });

      $chart.on('mousemove', function (event) {
        // For some reasons, on FF, we can't rely on event.offsetX and event.offsetY,
        // that's why we prioritize event.originalEvent.layerX and event.originalEvent.layerY
        // see https://github.com/gionkunz/chartist-js/issues/381
        $toolTip.css({
          left: (event.originalEvent.layerX || event.offsetX) - $toolTip.width() / 2 - 10,
          top: (event.originalEvent.layerY || event.offsetY) - $toolTip.height() - 40,
        });
      });
    };
  };

}

module.exports = {
  register,
};



// WEBPACK FOOTER //
// ./javascripts/components/chartist/tooltip_plugin.js